import React, { useState, useRef } from 'react';
import Modal from 'react-modal';
import { Formik } from 'formik';
import * as yup from 'yup';

import config from 'config/common';
import lib from 'lib/commons';

Modal.setAppElement('#root');

const ModalRegisterCollaborator = ({
	currentUser,
	modalStatus,
	closeModal,
	registerOfflineCollaborator,
	isRegisteringOfflineCollaborator
}) => {
	const hiddenFileFront = useRef(null);
	const hiddenFileBack = useRef(null);
	const hiddenFilePortrait = useRef(null);

	let userInfo = currentUser?.user ?? {};
	let allProvince = currentUser?.allAddress?.all_province ?? [];
	let allDistrict = currentUser?.allAddress?.all_district ?? [];

	let userProvince = allProvince.find(item => item.province_id == userInfo?.user_in_game?.province_id);
	let userDistrict = allDistrict.find(item => item.district_id == userInfo?.user_in_game?.district_id);

	const afterOpenModal = () => { };

	const selfClose = (event) => {
		event.preventDefault();
		closeModal();
	};

	const validate = () => {
		let optionsValidate = {
			id_place_of_issue: yup.string().trim('Không được có khoảng trắng ở đầu và cuối').strict(true).required('Hãy nhập thông tin'),
			email: yup.string().trim('Không được có khoảng trắng ở đầu và cuối').strict(true).email('Email không hợp lệ').required('Hãy nhập thông tin'),
			introduction: yup.string().trim('Không được có khoảng trắng ở đầu và cuối').strict(true).required('Hãy nhập thông tin').max(350, 'Tối đa 350 ký tự'),
			id_front_image: yup.string().required('Hãy tải ảnh'),
			id_back_image: yup.string().required('Hãy tải ảnh'),
			id_portrait_image: yup.string().required('Hãy tải ảnh'),
		};

		const schema = yup.object().shape(optionsValidate);

		return schema;
	};

	const handleClick = (e, type) => {
		e.preventDefault();
		e.stopPropagation();
		if (type == 1) {
			hiddenFileFront.current.click();
		}
		if (type == 2) {
			hiddenFileBack.current.click();
		}
		if (type == 3) {
			hiddenFilePortrait.current.click();
		}
	};

	const handleFileSelected = (e, type, setFieldValue, setFieldError, errors, touched) => {
		e.preventDefault();
		let allowedExtension = ['image/jpeg', 'image/jpg', 'image/png'];
		const file = e.target.files[0];
		const size = file.size;
		const name = file.name;
		const typeUpload = file.type;

		if (allowedExtension.indexOf(typeUpload) < 0) {
			if (type == 1) {
				setFieldError('id_front_image', 'Chỉ được upload ảnh');
				return false;
			}
			if (type == 2) {
				setFieldError('id_back_image', 'Chỉ được upload ảnh');
				return false;
			}
			if (type == 3) {
				setFieldError('id_portrait_image', 'Chỉ được upload ảnh');
				return false;
			}
		}

		if (size > 3000000) {
			if (type == 1) {
				setFieldValue('id_front_image', file);
				setFieldError('id_front_image', 'Dung lượng ảnh tối đa 3MB');
				return false;
			}

			if (type == 2) {
				setFieldValue('id_back_image', file);
				setFieldError('id_back_image', 'Dung lượng ảnh tối đa 3MB');
				return false;
			}

			if (type == 3) {
				setFieldValue('id_portrait_image', file);
				setFieldError('id_portrait_image', 'Dung lượng ảnh tối đa 3MB');
				return false;
			}
		}

		if (type == 1) {
			setFieldValue('id_front_image', file);
			setFieldError('id_front_image', '');
		}

		if (type == 2) {
			setFieldValue('id_back_image', file);
			setFieldError('id_back_image', '');
		}	

		if (type == 3) {
			setFieldValue('id_portrait_image', file);
			setFieldError('id_portrait_image', '');
		}
	};

	const handleRegisterCollaborator = (values) => {
		console.log('values', values);
		var formData = new FormData();

		for (var key in values) {
			formData.append(key, values[key]);
		}

		if(isRegisteringOfflineCollaborator) {
			return false;
		}

		lib.showMessage('Bạn có chắc chắn muốn đăng ký làm CTV không?', 'Huỷ').then((res) => {
			if(res.value) {
				registerOfflineCollaborator(formData, closeModal);
			}
		});
	};

	return (
		<Modal
			isOpen={modalStatus}
			onAfterOpen={afterOpenModal}
			onRequestClose={selfClose}
			contentLabel="Example Modal"
			portalClassName="ReactModalPortal"
			overlayClassName=""
			className="animated fadeInDown faster modal-register-collaborator modal-collaborator"
		>
			<h2>Đăng ký CTV Online</h2>
			<div className="modal-description">
				<Formik
					enableReinitialize={true}
					validationSchema={validate()}
					initialValues={{
						id_place_of_issue: '',
						email: '',
						introduction: '',
					}}
					onSubmit={(values, actions) => {
						handleRegisterCollaborator(values);
					}}
				>
					{({
						values,
						errors,
						touched,
						handleChange,
						handleBlur,
						handleSubmit,
						setFieldValue,
						setFieldError,
						isSubmitting,
						/* and other goodies */
					}) => (
						<form onSubmit={handleSubmit} className="my-form">
							<div className="row ">
								<div className="col-6">
									<div className="row">
										<div className="col-4">
											<label className="text-pink">Họ và tên:</label>
										</div>
										<div className="col-8 text-left text-system">
											{userInfo?.user_in_game?.name}
										</div>
									</div>
								</div>
								<div className="col-6">
									<div className="row ">
										<div className="col-4">
											<label className="text-pink">SĐT:</label>
										</div>
										<div className="col-8 text-left text-system">
											{userInfo?.user_in_game?.phone}
										</div>
									</div>
								</div>
							</div>

							<div className="row ">
								<div className="col-6">
									<div className="row ">
										<div className="col-4">
											<label className="text-pink">UID:</label>
										</div>
										<div className="col-8 text-left text-system">{userInfo?.user_in_game?.uid}</div>
									</div>
								</div>
								<div className="col-6">
									<div className="row ">
										<div className="col-4">
											<label className="text-pink">Tên HLV:</label>
										</div>
										<div className="col-8 text-left text-system">{userInfo?.user_in_game?.account_name}</div>
									</div>
								</div>
							</div>
							<div className="row align-items-center">
								<div className="col-4">
									<div className="row ">
										<div className="col-6">
											<label className="text-pink">cccd:</label>
										</div>
										<div className="col-6 text-left text-system">
											{userInfo?.user_in_game?.national_id}
										</div>
									</div>
								</div>
								<div className="col-8">
									<div className="row ">
										<div className="col-6">
											<input type="text" name="name" value={userProvince?.province_name} readOnly />
										</div>
										<div className="col-6">
											<input type="text" name="name" value={userDistrict?.district_name} readOnly />
										</div>
									</div>
								</div>
							</div>

							<div className="row align-items-center">
								<div className="col-2">
									<label className="text-pink">Nơi cấp</label>
								</div>
								<div className="col-10">
									<input type="text" name="id_place_of_issue"
										onChange={handleChange}
										value={values.id_place_of_issue || ''}
										onBlur={handleBlur} />

									{errors.id_place_of_issue && touched.id_place_of_issue && (<p className="text-error text-left text-danger">{errors.id_place_of_issue}</p>)}
								</div>
							</div>

							<div className="row align-items-center">
								<div className="col-5">
									<label className="text-pink">
										HÌNH CHỤP 2 MẶT CCCD <br /> & 1 ẢNH TAY CẦM MẶT TRƯỚC CCCD
									</label>
								</div>
								<div className="col-7 text-left">
									<div className="cccd-wrap">
										<div className="upload-img-wrap">
											<p>Ảnh mặt trước</p>
											<input
												type="file"
												name="id_front_image"
												className="input-none"
												ref={hiddenFileFront}
												accept="image/png, image/gif, image/jpeg"
												onChange={(e) => handleFileSelected(e, 1, setFieldValue, setFieldError, errors, touched)}
											/>
											<a href="#" onClick={(e) => handleClick(e, 1)}>
												{values.id_front_image ? <img src={URL.createObjectURL(values.id_front_image)} alt="" /> : <img src="/images/upload-img.png" alt="" />}
											</a>
											{errors.id_front_image && (<p className="text-error text-left text-danger">{errors.id_front_image}</p>)}
										</div>

										<div className="upload-img-wrap">
											<p>Ảnh mặt sau</p>
											<input
												type="file"
												name="id_back_image"
												className="input-none"
												ref={hiddenFileBack}
												accept="image/png, image/gif, image/jpeg"
												onChange={(e) => handleFileSelected(e, 2, setFieldValue, setFieldError, errors, touched)}
											/>
											<a href="#" onClick={(e) => handleClick(e, 2)}>
												{values.id_back_image ? <img src={URL.createObjectURL(values.id_back_image)} alt="" /> : <img src="/images/upload-img.png" alt="" />}
											</a>
											{errors.id_back_image && (<p className="text-error text-left text-danger">{errors.id_back_image}</p>)}
										</div>

										<div className="upload-img-wrap">
											<p>Ảnh cầm CCCD</p>
											<input
												type="file"
												name="id_portrait_image"
												className="input-none"
												ref={hiddenFilePortrait}
												accept="image/png, image/gif, image/jpeg"
												onChange={(e) => handleFileSelected(e, 3, setFieldValue, setFieldError, errors, touched)}
											/>
											<a href="#" onClick={(e) => handleClick(e, 3)}>
												{values.id_portrait_image ? <img src={URL.createObjectURL(values.id_portrait_image)} alt="" /> : <img src="/images/upload-img.png" alt="" />}
											</a>
											{errors.id_portrait_image && (<p className="text-error text-left text-danger">{errors.id_portrait_image}</p>)}
										</div>
										<div className="cccd-wrap__note">
											<p>
												*Vui lòng tải ảnh rõ nét, không mờ, không bị che khuất. Dung lượng ảnh tối đa 3MB
											</p>
										</div>
									</div>
								</div>
							</div>

							<div className="row align-items-center">
								<div className="col-2">
									<label className="text-pink">Email:</label>
								</div>
								<div className="col-10 text-left">
									<input type="text" name="email"
										onChange={handleChange}
										value={values.email || ''}
										onBlur={handleBlur} />

									{errors.email && touched.email && (<p className="text-error text-left text-danger">{errors.email}</p>)}
								</div>
							</div>

							<div className="row align-items-center">
								<div className="col-2">
									<label className="text-pink">Facebook:</label>
								</div>
								<div className="col-10 text-left text-system">
									{userInfo?.user_in_game?.facebook}
								</div>
							</div>

							<div className="row align-items-center">
								<div className="col-2">
									<label className="text-pink">
										Giới thiệu <br />
										Ngắn về <br />
										bản thân:
									</label>
								</div>
								<div className="col-10 text-left text-system">
									<textarea id="" name="introduction"
										onChange={handleChange}
										value={values.introduction || ''}
										onBlur={handleBlur}>
										Giới thiệu bản thân
									</textarea>
									{errors.introduction && touched.introduction && (<p className="text-error text-left text-danger">{errors.introduction}</p>)}
									
								</div>
							</div>

							<div className="hr-form"></div>

							<div className="row justify-content-center">
								<div className="col-4">
									<button type="submit" className="btn btn--submit btn--fw">
										Đăng ký
									</button>
								</div>
								<div className="col-4" onClick={(e) => selfClose(e)}>
									<button type="button" className="btn btn--cancel  btn--fw">
										Huỷ
									</button>
								</div>
							</div>
							<div className="row">
								<div className="col-12">
									<p className="note">
										*VUI LÒNG KIỂM TRA LẠI CÁC THÔNG TIN TRƯỚC KHI CHỌN ĐĂNG KÝ
									</p>
								</div>
							</div>
						</form>
					)}
				</Formik>
			</div>
		</Modal>
	);
};

export default ModalRegisterCollaborator;
